export const fileDownload = (response, fileName, fileFullName, type) => {
    if (response && (fileName || fileFullName)) {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileFullName ? fileFullName : `${fileName}.${type ? type : 'csv'}`}`);
        document.body.appendChild(link);
        link.click();
    }
}